<template>
    <div class="card-container">
        <a-tabs type="card" @change="callback">
            <a-tab-pane key="1" :tab="$t('moduleTitles.platformUpgrade')">
                <a-table
                        :data-source="upgradeList"
                        :loading="loading"
                        :pagination="pagination"
                        rowKey="id"
                        @change="handleTableChange"
                >
                    <a-table-column key="user_level_text" :title="$t('member.membership')" data-index="user_level_text"
                                    align="center"></a-table-column>
                    <a-table-column key="amount" :title="$t('member.total')" data-index="amount"
                                    align="center"></a-table-column>
                    <a-table-column key="num" :title="$t('member.num')" data-index="num"
                                    align="center"></a-table-column>
                    <a-table-column key="give_num" :title="$t('member.presentMouth')" data-index="give_num"
                                    align="center"></a-table-column>
                    <a-table-column key="icon_top_text" :title="$t('member.iconTop')" data-index="icon_top_text"
                                    align="center"></a-table-column>
                    <a-table-column key="icon_bottom_text" :title="$t('member.iconBottom')"
                                    data-index="icon_bottom_text" align="center"></a-table-column>
                    <a-table-column key="is_instalment" :title="$t('member.isiNstalment')" data-index="is_instalment"
                                    align="center">
                        <template slot-scope="text, record">
                            <span v-if="record.is_instalment==0">{{$t('member.no')}}</span>
                            <span v-else>{{$t('member.yes')}}</span>
                        </template>
                    </a-table-column>
                    <a-table-column key="name" :title="$t('member.ruleName')" data-index="name"
                                    align="center"></a-table-column>
                    <a-table-column key="description" :title="$t('member.ruleDescription')" data-index="description"
                                    align="center"></a-table-column>
                    <a-table-column key="operate" :title="$t('table.common.thead.operate')" align="center">
                        <template slot-scope="text, record">
                        <span>
                          <a @click.stop="edit(record)">{{$t(`actionTitles.edit`)}}</a>
                        </span>
                        </template>
                    </a-table-column>
                </a-table>
            </a-tab-pane>
            <a-tab-pane key="4" :tab="$t('moduleTitles.mealPlan')">
                <a-table
                        :data-source="upgradeList"
                        :loading="loading"
                        :pagination="pagination"
                        rowKey="id"
                        @change="handleTableChange"
                >
                    <a-table-column key="user_level_text" :title="$t('member.membership')" data-index="user_level_text"
                                    align="center"></a-table-column>
                    <a-table-column key="amount" :title="$t('member.total')" data-index="amount"
                                    align="center"></a-table-column>
                    <a-table-column key="num" :title="$t('member.num')" data-index="num"
                                    align="center"></a-table-column>
                    <a-table-column key="give_num" :title="$t('member.presentMouth')" data-index="give_num"
                                    align="center"></a-table-column>
                    <a-table-column key="icon_top_text" :title="$t('member.iconTop')" data-index="icon_top_text"
                                    align="center"></a-table-column>
                    <a-table-column key="icon_bottom_text" :title="$t('member.iconBottom')"
                                    data-index="icon_bottom_text" align="center"></a-table-column>
                    <a-table-column key="camera_type_text" :title="$t('member.cameraType')"
                                    data-index="camera_type_text" align="center"></a-table-column>
                    <a-table-column key="is_instalment" :title="$t('member.isiNstalment')" data-index="is_instalment"
                                    align="center">
                        <template slot-scope="text, record">
                            <span v-if="record.is_instalment==0">{{$t('member.no')}}</span>
                            <span v-else>{{$t('member.yes')}}</span>
                        </template>
                    </a-table-column>
                    <a-table-column key="name" :title="$t('member.ruleName')" data-index="name"
                                    align="center"></a-table-column>
                    <a-table-column key="description" :title="$t('member.ruleDescription')" data-index="description"
                                    align="center"></a-table-column>
                    <a-table-column key="operate" :title="$t('table.common.thead.operate')" align="center">
                        <template slot-scope="text, record">
                        <span>
                          <a @click.stop="edit(record)">{{$t(`actionTitles.edit`)}}</a>
                        </span>
                        </template>
                    </a-table-column>
                </a-table>
            </a-tab-pane>
            <a-tab-pane key="2" :tab="$t('moduleTitles.capacityToAddValue')">
                <a-table
                        :data-source="upgradeList"
                        :loading="loading"
                        :pagination="pagination"
                        rowKey="id"
                        @change="handleTableChange"
                >
                    <a-table-column key="user_level_text" :title="$t('member.membership')" data-index="user_level_text"
                                    align="center"></a-table-column>
                    <a-table-column key="amount" :title="$t('member.total')" data-index="amount"
                                    align="center"></a-table-column>
                    <a-table-column key="num" :title="$t('member.num')" data-index="num"
                                    align="center"></a-table-column>
                    <a-table-column key="icon_top_text" :title="$t('member.iconTop')" data-index="icon_top_text"
                                    align="center"></a-table-column>
                    <a-table-column key="icon_bottom_text" :title="$t('member.iconBottom')"
                                    data-index="icon_bottom_text" align="center"></a-table-column>
                    <a-table-column key="is_instalment" :title="$t('member.isiNstalment')" data-index="is_instalment"
                                    align="center">
                        <template slot-scope="text, record">
                            <span v-if="record.is_instalment==0">{{$t('member.no')}}</span>
                            <span v-else>{{$t('member.yes')}}</span>
                        </template>
                    </a-table-column>
                    <a-table-column key="name" :title="$t('member.ruleName')" data-index="name"
                                    align="center"></a-table-column>
                    <a-table-column key="description" :title="$t('member.ruleDescription')" data-index="description"
                                    align="center"></a-table-column>
                    <a-table-column key="operate" :title="$t('table.common.thead.operate')" align="center">
                        <template slot-scope="text, record">
                        <span>
                          <a @click.stop="edit(record)">{{$t(`actionTitles.edit`)}}</a>
                        </span>
                        </template>
                    </a-table-column>
                </a-table>
            </a-tab-pane>
            <a-tab-pane key="5" :tab="$t('moduleTitles.teamBonus')">
                <a-table
                        :data-source="upgradeList"
                        :loading="loading"
                        :pagination="pagination"
                        rowKey="id"
                        @change="handleTableChange"
                >
                    <a-table-column key="user_level_text" :title="$t('member.membership')" data-index="user_level_text"
                                    align="center"></a-table-column>
                    <a-table-column key="amount" :title="$t('member.total')" data-index="amount"
                                    align="center"></a-table-column>
                    <a-table-column key="num" :title="$t('member.num')" data-index="num"
                                    align="center"></a-table-column>
                    <a-table-column key="icon_top_text" :title="$t('member.iconTop')" data-index="icon_top_text"
                                    align="center"></a-table-column>
                    <a-table-column key="icon_bottom_text" :title="$t('member.iconBottom')"
                                    data-index="icon_bottom_text" align="center"></a-table-column>
                    <a-table-column key="is_instalment" :title="$t('member.isiNstalment')" data-index="is_instalment"
                                    align="center">
                        <template slot-scope="text, record">
                            <span v-if="record.is_instalment==0">{{$t('member.no')}}</span>
                            <span v-else>{{$t('member.yes')}}</span>
                        </template>
                    </a-table-column>
                    <a-table-column key="name" :title="$t('member.ruleName')" data-index="name"
                                    align="center"></a-table-column>
                    <a-table-column key="description" :title="$t('member.ruleDescription')" data-index="description"
                                    align="center"></a-table-column>
                    <a-table-column key="operate" :title="$t('table.common.thead.operate')" align="center">
                        <template slot-scope="text, record">
                        <span>
                          <a @click.stop="edit(record)">{{$t(`actionTitles.edit`)}}</a>
                        </span>
                        </template>
                    </a-table-column>
                </a-table>
            </a-tab-pane>
            <a-tab-pane key="3" :tab="$t('moduleTitles.camerasPurchased')">
                <a-table
                        :data-source="upgradeList"
                        :loading="loading"
                        :pagination="pagination"
                        rowKey="id"
                        @change="handleTableChange"
                >
                    <a-table-column key="user_level_text" :title="$t('member.membership')" data-index="user_level_text"
                                    align="center"></a-table-column>
                    <a-table-column key="amount" :title="$t('member.total')" data-index="amount"
                                    align="center"></a-table-column>
                    <a-table-column key="num" :title="$t('member.num')" data-index="num"
                                    align="center"></a-table-column>
                    <a-table-column key="icon_top_text" :title="$t('member.iconTop')" data-index="icon_top_text"
                                    align="center"></a-table-column>
                    <a-table-column key="camera_type_text" :title="$t('member.cameraType')"
                                    data-index="camera_type_text" align="center"></a-table-column>
                    <a-table-column key="icon_bottom_text" :title="$t('member.iconBottom')"
                                    data-index="icon_bottom_text" align="center"></a-table-column>
                    <a-table-column key="is_instalment" :title="$t('member.isiNstalment')" data-index="is_instalment"
                                    align="center">
                        <template slot-scope="text, record">
                            <span v-if="record.is_instalment==0">{{$t('member.no')}}</span>
                            <span v-else>{{$t('member.yes')}}</span>
                        </template>
                    </a-table-column>
                    <a-table-column key="name" :title="$t('member.ruleName')" data-index="name"
                                    align="center"></a-table-column>
                    <a-table-column key="description" :title="$t('member.ruleDescription')" data-index="description"
                                    align="center"></a-table-column>
                    <a-table-column key="operate" :title="$t('table.common.thead.operate')" align="center">
                        <template slot-scope="text, record">
                        <span>
                          <a @click.stop="edit(record)">{{$t(`actionTitles.edit`)}}</a>
                        </span>
                        </template>
                    </a-table-column>
                </a-table>
            </a-tab-pane>
            <a-tab-pane key="9" :tab="$t('moduleTitles.workUpgrade')">
                <a-table
                        :data-source="upgradeList"
                        :loading="loading"
                        :pagination="pagination"
                        rowKey="id"
                        @change="handleTableChange"
                >
                    <a-table-column key="user_level_text" :title="$t('member.membership')" data-index="user_level_text"
                                    align="center"></a-table-column>
                    <a-table-column key="amount" :title="$t('member.total')" data-index="amount"
                                    align="center"></a-table-column>
                    <a-table-column key="num" :title="$t('member.num')" data-index="num"
                                    align="center"></a-table-column>
                    <a-table-column key="icon_top_text" :title="$t('member.iconTop')" data-index="icon_top_text"
                                    align="center"></a-table-column>
                    <a-table-column key="icon_bottom_text" :title="$t('member.iconBottom')"
                                    data-index="icon_bottom_text" align="center"></a-table-column>
                    <a-table-column key="is_instalment" :title="$t('member.isiNstalment')" data-index="is_instalment"
                                    align="center">
                        <template slot-scope="text, record">
                            <span v-if="record.is_instalment==0">{{$t('member.no')}}</span>
                            <span v-else>{{$t('member.yes')}}</span>
                        </template>
                    </a-table-column>
                    <a-table-column key="name" :title="$t('member.ruleName')" data-index="name"
                                    align="center"></a-table-column>
                    <a-table-column key="description" :title="$t('member.ruleDescription')" data-index="description"
                                    align="center"></a-table-column>
                    <a-table-column key="operate" :title="$t('table.common.thead.operate')" align="center">
                        <template slot-scope="text, record">
                        <span>
                          <a @click.stop="edit3DPlan(record)">{{$t(`actionTitles.edit`)}}</a>
                        </span>
                        </template>
                    </a-table-column>
                </a-table>
            </a-tab-pane>
            <a-tab-pane key="6" :tab="$t('moduleTitles.membershipPrivileges')">
                <a-button type="primary" :style="{ margin: '10px 15px' }" @click="addRegion">
                    {{$t('actionTitles.add')}}
                </a-button>
                <a-button type="primary" :style="{ margin: '10px 15px' }" @click="editMIntr">
                    {{$t('member.modifMemberD')}}
                </a-button>
                <a-table
                        :data-source="upgradeList"
                        :loading="loading"
                        :pagination="pagination"
                        rowKey="id"
                        @change="handleTableChange"
                >
                    <a-table-column key="name" :title="$t('member.name')" data-index="name"
                                    align="center"></a-table-column>
                    <a-table-column key="introduce" :title="$t('member.introduce')" data-index="introduce"
                                    align="center"></a-table-column>
                    <a-table-column key="icon" :title="$t('member.icon')" data-index="icon" align="center">
                        <template slot-scope="text, record">
                            <img :src="record.icon" class="edit-icon"/>
                        </template>
                    </a-table-column>
                    <a-table-column key="operate" :title="$t('table.common.thead.operate')" align="center">
                        <template slot-scope="text, record">
                        <span>
                          <a @click.stop="editM(record)">{{$t(`actionTitles.edit`)}}</a>
                        </span>
                            <a-divider type="vertical"/>
                            <a-popconfirm
                                    :cancelText="$t('actionTitles.cancel')"
                                    :okText="$t('actionTitles.confirm')"
                                    :title="$t('message.softDeleteHint')"
                                    @confirm="() => deleteInfoM(record.id)"
                            >
                                <a href="javascript:;" style="color: red">{{$t(`actionTitles.delete`)}}</a>
                            </a-popconfirm>
                        </template>
                    </a-table-column>
                </a-table>
            </a-tab-pane>
            <a-tab-pane key="7" :tab="$t('moduleTitles.commonProblem')">
                <a-button type="primary" :style="{ margin: '10px 15px' }" @click="addRegion">
                    {{$t('actionTitles.add')}}
                </a-button>
                <a-table
                        :data-source="upgradeList"
                        :loading="loading"
                        :pagination="pagination"
                        rowKey="id"
                        @change="handleTableChange"
                >
                    <a-table-column key="question" :title="$t('member.question')" data-index="question"
                                    align="center"></a-table-column>
                    <a-table-column key="answer" :title="$t('member.answer')" data-index="answer"
                                    align="center"></a-table-column>
                    <a-table-column key="operate" :title="$t('table.common.thead.operate')" align="center">
                        <template slot-scope="text, record">
                        <span>
                          <a @click.stop="editQ(record)">{{$t(`actionTitles.edit`)}}</a>
                        </span>
                            <a-divider type="vertical"/>
                            <a-popconfirm
                                    :cancelText="$t('actionTitles.cancel')"
                                    :okText="$t('actionTitles.confirm')"
                                    :title="$t('message.softDeleteHint')"
                                    @confirm="() => deleteInfoQ(record.id)"
                            >
                                <a href="javascript:;" style="color: red">{{
                                    $t(`actionTitles.delete`)
                                    }}</a>
                            </a-popconfirm>
                        </template>
                    </a-table-column>
                </a-table>
            </a-tab-pane>
            <a-tab-pane key="8" :tab="$t('member.installment')">
                <a-table
                        :data-source="upgradeList"
                        :loading="loading"
                        rowKey="id"
                >
                    <a-table-column key="id" :title="$t('member.serialNumber')" data-index="id"
                                    align="center"></a-table-column>
                    <a-table-column key="type_text" :title="$t('member.serialNumber')" data-index="type_text"
                                    align="center"></a-table-column>
                    <a-table-column key="installment_text" :title="$t('member.paymentInstallment')"
                                    data-index="installment_text" align="center"></a-table-column>
                    <a-table-column key="interest" :title="$t('member.PercentageIncreasePlatform')"
                                    data-index="interest" align="center">
                        <template slot-scope="text,record">
                            <span v-if="record.type!=3">{{record.interest}}%</span>
                            <span v-else>-</span>
                        </template>
                    </a-table-column>
                    <a-table-column key="operate" :title="$t('table.common.thead.operate')" align="center">
                        <template slot-scope="text, record">
                      <span v-if="record.type!=3">
                        <a @click.stop="editS(record)">{{$t(`actionTitles.edit`)}}</a>
                      </span>
                            <span v-else></span>
                        </template>
                    </a-table-column>
                </a-table>
            </a-tab-pane>
        </a-tabs>

        <a-modal
                :title="$t('actionTitles.edit')"
                :visible="exitVisible"
                @ok="saveRegion"
                @cancel="close"
                :destroyOnClose="true"
                keyboard
        >
            <a-form :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
                <template v-if="mImg">
                    <a-form-item :label="$t('member.memberDetail')">
                        <div class="logo" v-if="memberDetail">
                            <img :src="memberDetail" class="edit-big-img"/>
                        </div>
                        <DragUploader
                                uptype="logo"
                                @updateImagefiles="getImages"
                                style="display: inline-block"
                        >
                            <a-button type="primary" slot="body">{{$t('member.chooseImg')}}</a-button>
                        </DragUploader>
                    </a-form-item>
                </template>
                <template v-else>
                    <template v-if="changeKey=='6'">
                        <a-form-item label="ICON">
                            <div class="logo" v-if="addData.icon">
                                <img :src="addData.icon" class="edit-icon"/>
                            </div>
                            <DragUploader
                                    uptype="logo"
                                    @updateImagefiles="getUploaderIcon"
                                    style="display: inline-block"
                            >
                                <a-button type="primary" slot="body">{{$t('member.chooseImg')}}</a-button>
                            </DragUploader>
                        </a-form-item>
                        <a-form-item :label="$t('member.name')">
                            <a-input v-model="addData.name" :placeholder="$t('member.nameErr')"/>
                        </a-form-item>
                        <a-form-item :label="$t('member.introduce')">
                            <a-input v-model="addData.introduce" :placeholder="$t('member.introduceErr')"/>
                        </a-form-item>
                        <a-form-item :label="$t('member.detailImg')">
                            <div class="logo" v-if="addData.detail">
                                <img :src="addData.detail" class="edit-img"/>
                            </div>
                            <DragUploader
                                    uptype="logo"
                                    @updateImagefiles="getUploaderImages"
                                    style="display: inline-block"
                            >
                                <a-button type="primary" slot="body">{{$t('member.chooseImg')}}</a-button>
                            </DragUploader>
                        </a-form-item>
                    </template>
                    <template v-else-if="changeKey=='7'">
                        <a-form-item :label="$t('member.question')">
                            <a-input v-model="problemData.question" :placeholder="$t('member.questionErr')"/>
                        </a-form-item>
                        <a-form-item :label="$t('member.answer')">
                            <a-input v-model="problemData.answer" :placeholder="$t('member.answerErr')"/>
                        </a-form-item>
                    </template>
                    <template v-else-if="changeKey=='9'">
                        <a-form-item :label="$t('member.isiNstalment')">
                            <a-radio-group v-model="editFormData.is_instalment">
                                <a-radio :value="1">{{$t('member.yes')}}</a-radio>
                                <a-radio :value="0">{{$t('member.no')}}</a-radio>
                            </a-radio-group>
                        </a-form-item>
                        <a-form-item :label="$t('member.total')">
                            <a-input v-model="editFormData.amount" :placeholder="$t('member.totalErr')"/>
                        </a-form-item>
                        <a-form-item :label="$t('member.num')">
                            <a-input v-model="editFormData.num" :placeholder="$t('member.numErr')"/>
                        </a-form-item>
                        <a-form-item :label="$t('member.iconTop')">
                            <a-input v-model="editFormData.icon_top_text" :placeholder="$t('member.iconTopErr')"/>
                        </a-form-item>
                        <a-form-item :label="$t('member.iconBottom')">
                            <a-input v-model="editFormData.icon_bottom_text" :placeholder="$t('member.iconBottomErr')"/>
                        </a-form-item>
                        <a-form-item :label="$t('member.ruleName')">
                            <a-input v-model="editFormData.name" :placeholder="$t('member.ruleNameErr')"/>
                        </a-form-item>
                        <a-form-item :label="$t('member.ruleDescription')">
                            <a-input v-model="editFormData.description" :placeholder="$t('member.ruleDescriptionErr')"/>
                        </a-form-item>
                    </template>
                    <template v-else>
                        <a-form-item :label="$t('member.cameraType')" v-if="changeKey=='4' || changeKey=='3'">
                            <a-select
                                    label-in-value
                                    :default-value="{key: editFormData.camera_type_text}"
                                    style="width: 120px"
                                    @change="handleChangel"
                            >
                                <a-select-option
                                        v-for="item in fieldList"
                                        :key="item.camera_type"
                                        :value="item.camera_type"
                                >{{ item.camera_type_text }}
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item :label="$t('member.isiNstalment')" v-if="changeKey>='1' && changeKey <= '5'">
                            <a-radio-group v-model="editFormData.is_instalment">
                                <a-radio :value="1">{{$t('member.yes')}}</a-radio>
                                <a-radio :value="0">{{$t('member.no')}}</a-radio>
                            </a-radio-group>
                        </a-form-item>
                        <a-form-item :label="$t('member.presentMouth')" v-if="changeKey=='4' || changeKey=='1'">
                            <a-input v-model="editFormData.give_num" :placeholder="$t('member.presentMouthErr')"/>
                        </a-form-item>
                        <a-form-item :label="$t('member.total')">
                            <a-input v-model="editFormData.amount" :placeholder="$t('member.totalErr')"/>
                        </a-form-item>
                        <a-form-item :label="$t('member.num')">
                            <a-input v-model="editFormData.num" :placeholder="$t('member.numErr')"/>
                        </a-form-item>
                        <a-form-item :label="$t('member.iconTop')">
                            <a-input v-model="editFormData.icon_top_text" :placeholder="$t('member.iconTopErr')"/>
                        </a-form-item>
                        <a-form-item :label="$t('member.iconBottom')">
                            <a-input v-model="editFormData.icon_bottom_text" :placeholder="$t('member.iconBottomErr')"/>
                        </a-form-item>
                        <a-form-item :label="$t('member.ruleName')">
                            <a-input v-model="editFormData.name" :placeholder="$t('member.ruleNameErr')"/>
                        </a-form-item>
                        <a-form-item :label="$t('member.ruleDescription')">
                            <a-input v-model="editFormData.description" :placeholder="$t('member.ruleDescriptionErr')"/>
                        </a-form-item>
                    </template>
                </template>
            </a-form>
        </a-modal>
        <a-modal
                :title="$t('actionTitles.edit')"
                :visible="isShow"
                @ok="saveEdit"
                @cancel="quit"
                keyboard
        >
            <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }">
                <a-form-item :label="$t('member.PercentageIncreasePlatform')">
                    <a-input v-model="platform.interest" :placeholder="$t('member.pleaseEnterValue')"/>
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>
<script>
/*eslint-disable*/
    import {pageQuery} from "@/api/payConfig";
    import DragUploader from "@/components/DragUploader";
    import {
        privilegeList,
        problemList,
        deletePrivilege,
        deleteProblem,
        editSome,
        savePrivilege,
        saveProblem,
        MemberDifferent,
        saveMemberDifferent,
        instalmentList,
        updInterest
    } from "@/api/member";

    export default {
        components: {DragUploader},
        data() {
            return {
                memberDetail: '',
                loading: false,
                //升級解鎖list
                upgradeList: [],
                pagination: {
                    current: 1,
                    pageSize: 10,
                    total: 0,
                },
                exitVisible: false,
                changeKey: '',
                editFormData: {
                    give_num: '',
                    user_level_text: '',
                    amount: '',
                    num: '',
                    icon_top_text: '',
                    icon_bottom_text: '',
                    description: '',
                    is_instalment: 1,

                    detail: '',
                    icon: '',
                    introduce: '',
                    name: '',

                    answer: '',
                    question: '',
                },
                fieldList: [
                    {camera_type: '0', camera_type_text: '無'},
                    {camera_type: '1', camera_type_text: '8k相機'},
                    {camera_type: '2', camera_type_text: '10k相機'},
                ],
                addData: {
                    detail: '',
                    icon: '',
                    introduce: '',
                    name: '',
                },
                problemData: {
                    question: '',
                    answer: ''
                },
                platform: {},
                mImg: '',
                isShow: false,
                searchParam: {
                    current_page: 1,
                    per_page: 10,
                    type: 1
                },
                searchData: {
                    current_page: 1,
                    per_page: 10,
                }
            }
        },
        mounted() {
            this.changeKey = '1';
            // let searchParam = {
            //         current_page: this.pagination.current,
            //         per_page: this.pagination.pageSize,
            //         type:1,
            //     };
            this.loadData(this.searchParam);
        },
        methods: {
            getUploaderImages(list) {
                this.addData.detail = list[0].url;
            },
            getUploaderIcon(list) {
                this.addData.icon = list[0].url;
            },
            getImages(list) {
                this.memberDetail = list[0].url;
            },
            //獲取會員詳情圖
            editMIntr() {
                MemberDifferent().then(res => {
                    if (res.code === 1) {
                        this.memberDetail = res.data.member_different;
                        this.exitVisible = true;
                        this.mImg = '1';
                    }
                })
            },
            loadData(data) {
                this.loading = true;
                pageQuery(data)
                    .then((res) => {
                        if (res.code === 1) {
                            this.loading = false;
                            this.upgradeList = res.data.data;
                            this.pagination.total = res.data.total;
                        }
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            },
            //分頁
            handleTableChange(pagination, filters, sorter) {
                this.pagination = pagination;
                this.getAll();
            },
            edit(region) {
                this.editFormData = this.$deepClone(region);
                console.log(this.editFormData)
                this.exitVisible = true;
            },
            //獲取會員特權列表
            MemberPrivilege() {
                let search = {
                    ...this.searchData,
                    current_page: this.pagination.current,
                    per_page: this.pagination.pageSize,

                }
                privilegeList(search).then(res => {
                    this.loading = false;
                    this.upgradeList = res.data.data;
                    this.pagination.total = res.data.total;
                })
            },
            //獲取問題列表
            problem() {
                let search = {
                    ...this.searchData,
                    current_page: this.pagination.current,
                    per_page: this.pagination.pageSize,

                }
                problemList(search).then(res => {
                    this.loading = false;
                    this.upgradeList = res.data.data;
                    this.pagination.total = res.data.total;
                })
            },
            //獲取分期列表
            Staging() {
                instalmentList().then(res => {
                    this.loading = false;
                    this.upgradeList = res.data;
                })
            },
            callback(key) {
                this.changeKey = key;
                this.getAll();
            },
            getAll() {
                this.upgradeList = [];
                if (this.changeKey === "6") {
                    this.MemberPrivilege();
                } else if (this.changeKey === "7") {
                    this.problem();
                } else if (this.changeKey === "8") {
                    this.Staging();
                } else {
                    let searchParam = {
                        ...this.searchParam,
                        current_page: this.pagination.current,
                        per_page: this.pagination.pageSize,
                        type: this.changeKey

                    }
                    this.loadData(searchParam);
                }
            },
            //刪除
            deleteInfoM(id) {
                deletePrivilege({id: id})
                    .then((res) => {
                        if (res.code === 1) {
                            this.$message.success(this.$t("message.deleteSuccess"), 2, () => {
                                this.upgradeList = [];
                                this.MemberPrivilege();
                            });
                        }
                    })
                    .catch((err) => {
                    });
            },
            deleteInfoQ(id) {
                deleteProblem({id: id})
                    .then((res) => {
                        if (res.code === 1) {
                            this.$message.success(this.$t("message.deleteSuccess"), 2, () => {
                                this.upgradeList = [];
                                this.MemberPrivilege();
                            });
                        }
                    })
                    .catch((err) => {
                    });
            },
            //打開新增框
            addRegion() {
                this.addData = {
                    detail: '',
                    icon: '',
                    introduce: '',
                    name: '',
                },
                    this.problemData = {
                        question: '',
                        answer: ''
                    },
                    this.exitVisible = true;
            },
            //打開編輯框
            editM(region) {
                let FormData = this.$deepClone(region);
                this.addData = {
                    id: FormData.id,
                    detail: FormData.detail,
                    icon: FormData.icon,
                    introduce: FormData.introduce,
                    name: FormData.name,
                }
                this.exitVisible = true;
            },
            editQ(region) {
                let FormData = this.$deepClone(region);
                this.problemData = {
                    id: FormData.id,
                    question: FormData.question,
                    answer: FormData.answer,
                }
                this.exitVisible = true;
            },
            editS(region) {
                let FormData = this.$deepClone(region);
                this.platform = {
                    id: FormData.id,
                    interest: FormData.interest,
                }
                this.isShow = true;
            },
            //判斷編輯類型
            saveRegion() {
                if (this.mImg) {
                    saveMemberDifferent({member_different: this.memberDetail}).then(res => {
                        this.$message.success(this.$t("member.editeSuccse"))
                        this.exitVisible = false;
                        this.mImg = '';
                    })
                } else {


                    if (this.changeKey === '6') {
                        savePrivilege(this.addData).then(res => {
                            if (res.code === 1) {
                                this.MemberPrivilege();
                                this.$message.success(this.$t("member.editeSuccse"))
                                this.exitVisible = false;
                            }
                        })
                    } else if (this.changeKey === '7') {
                        saveProblem(this.problemData).then(res => {
                            if (res.code === 1) {
                                this.problem();
                                this.$message.success(this.$t("member.editeSuccse"));
                                this.exitVisible = false;
                            }
                        })
                    } else {
                        editSome(this.editFormData).then(res => {
                            if (res.code === 1) {
                                this.getAll();
                                this.exitVisible = false;
                                this.$message.success(this.$t("member.editeSuccse"))
                            }
                        })
                    }
                }
            },
            close() {
                this.exitVisible = false;
                this.mImg = '';
                // this.editFormData.
                // this.$refs.editFormData.resetFields();
            },
            //編輯分期付款
            saveEdit() {
                updInterest(this.platform).then(res => {
                    if (res.code === 1) {
                        this.Staging();
                        this.isShow = false;
                        this.$message.success(this.$t("member.editeSuccse"))
                    }
                })
            },
            quit() {
                this.isShow = false;
            },

            handleChangel(value) {
                this.editFormData.camera_type = value.key;
                this.editFormData.camera_type_text = value.label;
            },
            edit3DPlan(data) {
                this.editFormData = this.$deepClone(data);
                this.exitVisible = true
            },
        },
    }
</script>
<style lang="less">
    .ant-tabs {
        padding-bottom: 20px;
    }

    .card-container {
        background: #f5f5f5;
        overflow: hidden;
    }

    .card-container > .ant-tabs-card > .ant-tabs-content {
        margin-top: -16px;
    }

    .card-container > .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
        background: #fff;
        padding: 16px;
    }

    .card-container > .ant-tabs-card > .ant-tabs-bar {
        border-color: #fff;
    }

    .card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
        border-color: transparent;
        background: transparent;
    }

    .card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
        border-color: #fff;
        background: #fff;
    }

    .edit-img {
        width: 150px;
        // height: 200px;
    }

    .edit-big-img {
        width: 240px;
        // height: 200px;
    }

    .edit-icon {
        width: 70px;
        //  height: 40px;
    }

    .logo {
        // width: 150px;
        // height: 200px;
        position: relative;

        &:hover {
            .delete-btn {
                opacity: 1;
            }
        }

        .delete-btn {
            opacity: 0;
            position: absolute;
            z-index: 1;
            top: 2px;
            left: 2px;
            width: 20px;
            height: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 2px;
            background-color: rgba(0, 0, 0, 0.5);
            transition: background-color 0.3s ease;
            cursor: pointer;
            color: #ffffff;

            &:hover {
                background-color: rgba(0, 0, 0, 0.6);
            }
        }

        img {
            height: 100%;
            object-fit: contain;
        }
    }
</style>